module.exports = __webpack_public_path__ + "static/media/video-back.7d9df377.png";